<template>
    <div>
        <div class="title">Map preview: {{map.name}}</div>

        <div :v-if="!isLoading">
            <map-previewer :height="600" :center="center" :mapType="mapType" :markers="markers" ref="map_previewer">

            </map-previewer>
        </div>

        <div>&nbsp;</div>

        <b-button class="button is-light btn-margin" @click.prevent="cancel()" icon-left="chevron-left">
            Back to maps list
        </b-button>

        <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
    </div>
</template>

<script>
  import MapPreviewer from './single/MapPreviewer'
  import displayHelper from '../helpers/display-helper'
  import mapService from '../services/mapService'

  export default {
    data() {
      return {
        error: '',
        mapId: '',
        map: {},
        isLoading: true,
        title: '',
        center: {lat: 1.3581036, lng: 103.8329625},
        markers: [],
        mapType: 'terrain'
      }
    },
    components: {
      MapPreviewer
    },

    async created() {
      try {
        if (this.$route.params.id) {
          this.mapId = this.$route.params.id
          this.map = await mapService.getMapInfos(this.mapId)
          this.displayTitle()
          this.markers = this.map.geolocationPoints
          this.isLoading = false
        } else {
          displayHelper.displayError(this, 'MapId was not found in URL')
          this.displayErrors(['Oops - MapId was not found in URL'])
        }
      } catch (err) {
        displayHelper.displayError(this, 'Failed to display preview for this map - please contact support')
      }
    },

    methods: {
      displayTitle() {
        this.title = `Map preview: ${this.map.mapName}`
      },
      cancel() {
        this.$router.go(-1)
      }
    }
  }
</script>
